/* global hj */
if (process.browser) {
  window.hj = window.hj || // eslint-disable-next-line func-names
  function () {
    // eslint-disable-next-line prefer-rest-params
    (hj.q = hj.q || []).push(arguments);
  };
}

export function tagEvent(tag) {
  hj('tagRecording', [tag]);
}